import generic_logo_club from '../assets/images/logo_generic_club.png';

// Fonction créée pour supprimer les doublons car mapbox renvoyait les clubs en doubles dans l'array de features
// Utilisée dans les controller.js des différentes MapBox
export function filterFeatures(features) {
    let idsAlreadyAdded = [];
    let res = [];
    features.forEach((feature) => {
        if (!idsAlreadyAdded.includes(feature.properties.id)) {
            idsAlreadyAdded.push(feature.properties.id);
            res.push(feature);
        }
    });
    return res;
}

const clubLogoServer =
    window.FFHANBALL_MEDIA_CLUBS ?? 'https://media-logos-clubs.ffhandball.fr';

/**
 * Convertit le chemin du logo en une URL structurée avec le format .webp et une taille spécifique.
 * @param {string | null | undefined} logo - Le chemin du fichier logo, ou null/undefined si non spécifié.
 * @param {64 | 128 | 256 | 512} size - La taille désirée pour le logo. Doit être l'une des valeurs spécifiées.
 * @returns {string} L'URL structurée du logo en format .webp, ou un logo généric si le logo n'est pas spécifié.
 */
export const toStructureLogoSrc = (logo, size) =>
    logo
        ? `${clubLogoServer}/${size}/${logo.split('.').slice(0, -1).join('.')}.webp`
        : generic_logo_club;

const formatDay = (date) =>
    date.toLocaleDateString('fr-FR', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
    });

const formatTime = (date) =>
    date.toLocaleTimeString('fr-FR', { hour: 'numeric', minute: 'numeric' });

export const formatDateTimeRange = (start, end) => {
    const startDate = new Date(start);
    const endDate = new Date(end);

    const startDay = formatDay(startDate);
    const endDay = formatDay(endDate);
    const startTime = formatTime(startDate);
    const endTime = formatTime(endDate);

    if (startDay === endDay) {
        return `Le ${startDay}, de ${startTime} à ${endTime}`;
    } else {
        const startMonthYear = startDate.toLocaleDateString('fr-FR', {
            month: 'long',
            year: 'numeric',
        });
        const endMonthYear = endDate.toLocaleDateString('fr-FR', {
            month: 'long',
            year: 'numeric',
        });

        if (startMonthYear === endMonthYear) {
            const startDayOnly = startDate.getDate();
            const endDayOnly = endDate.getDate();
            return `Du ${startDayOnly} au ${endDayOnly} ${startMonthYear}, de ${startTime} à ${endTime}`;
        } else {
            return `Du ${startDay} au ${endDay}, de ${startTime} à ${endTime}`;
        }
    }
};

const toFormattedEuros = (cents) => {
    const euros = cents / 100;
    const eurosFixed = euros.toFixed(2); // Convert to a string with 2 decimal places
    // Remove fractional part if it is zero
    if (eurosFixed.endsWith('.00')) {
        return `${parseInt(eurosFixed)} €`;
    } else {
        return eurosFixed.replace('.', '€');
    }
};

// Helper function to convert cents to Euros with your preferred format
export const formatPriceRange = (minCents, maxCents) => {
    const minPrice = toFormattedEuros(minCents);
    const maxPrice = toFormattedEuros(maxCents);

    if (minCents === maxCents) {
        return `${minPrice}`;
    } else {
        return `De ${minPrice} à ${maxPrice}`;
    }
};
